import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import * as _ from '../lodash';
import course from '../page/CoursePage';
import store from '../configureStore';
import * as cartActions from '../actions/cart';
import * as settingsActions from '../actions/settings';
import * as productActions from '../actions/products';
import * as frameActions from '../actions/frames';
import * as orderActions from '../actions/orders';

const mapStateToProps = ({ product, frames, order, settings }) => ({
  ...settings,
  order,
  frames,
  variants: product.data.variants,
  isDemo: window.bta.isDemo,
});

const mapDispatchToProps = dispatch => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
});

const Course = connect(
  mapStateToProps,
  mapDispatchToProps,
)(course);

export default class CourseWidgetContainer extends Component {
  UNSAFE_componentWillMount() {
    const { product, defaultSetting, defaultTranslation, exceededTrialPlan } = this.props;
    let { settings } = this.props;
    const newStyle = window.xprops.data && window.xprops.data.style;

    if (newStyle) {
      settings = _.deepMerge(settings, { style: newStyle });
    }

    store.dispatch(
      settingsActions.setConfiguration({
        ...settings,
        defaultSetting,
        defaultTranslation,
        exceededTrialPlan
      }),
    );

    store.dispatch(productActions.fetchProduct(product));
    store.dispatch(
      orderActions.setVariantsQuantity(`${product.variants[0].external_id}_quantity`, 1, { singleVariant: true }),
    );

    if (!exceededTrialPlan) this.loadFrames();
  }

  loadFrames() {
    const { product, settings } = this.props;

    let availableDates = 270; // default 9 months
    if (settings.setting
      && settings.setting.max_number_of_months
      && parseInt(settings.setting.max_number_of_months, 10)
    ) {
      availableDates = 30 * parseInt(settings.setting.max_number_of_months, 10);
    }

    const params = product.terms.map((term) => {
      const startDate = moment(term.start_date);
      const finishDate = moment(term.finish_date);
      const availableDate = moment(term.start_date).add(availableDates, 'days');
      let date = finishDate <= availableDate ? finishDate : availableDate;
      if (startDate.isSame(date, 'date')) {
        date = moment(term.start_date).add(1, 'days');
      }

      return {
        start: startDate,
        finish: date,
      };
    });

    store.dispatch(
      frameActions.fetchCourseFrames(params, false),
    );
  }

  componentDidMount() {
    const { settings } = this.props;

    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(settings.setting);
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <Course {...this.props} />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = value => store.dispatch(settingsActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingsActions.setTranslation(key, value));
};
window.changeSetting = (key, value) => store.dispatch(settingsActions.setSetting(key, value));
